"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const partners = [{
  name: "Elite Sports",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/partner_elite_sports.png"
}, {
  name: "Gold Coast Finance",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/partner_gold_finance.png"
}, {
  name: "Birkalla Logistics",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/partner_birkalla_logistics.png"
}, {
  name: "Trophy Real Estate",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/partner_trophy_realestate.png"
}, {
  name: "Pitch Performance",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/partner_pitch_performance.png"
}, {
  name: "Legacy Wealth",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/partner_legacy_wealth.png"
}, {
  name: "Apex Medical",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/partner_apex_medical.png"
}];
export default function VisionaryPartnerships() {
  const duplicatedPartners = [...partners, ...partners];
  return <section data-section-id="223728" id="our-elite-partners" className="bg-background text-foreground relative py-16 overflow-hidden flex flex-col justify-center">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-scroll {
          animation: marquee-scroll 60s linear infinite;
        }
        .marquee-container:hover .animate-marquee-scroll {
          animation-play-state: paused;
        }
      `}</style>

      <Separator className="bg-border absolute top-0 left-0 w-full opacity-50" />

      <div className="marquee-container w-full overflow-hidden flex items-center group cursor-default">
        <div className="flex w-max animate-marquee-scroll items-center gap-24 pr-24">
          {duplicatedPartners.map((partner, i) => <div key={i} data-index={i} className="flex-shrink-0 flex items-center justify-center w-40 h-20 transition-all duration-700 ease-in-out">
              <img src={partner.logo} alt={`${partner.name} logo`} className="max-w-full max-h-full object-contain filter grayscale brightness-0 invert-[0.5] sepia-[1] saturate-[5] hue-rotate-[10deg] opacity-40 group-hover:opacity-60 hover:!opacity-100 transition-opacity duration-500" />
            </div>)}
        </div>
      </div>

      <Separator className="bg-border absolute bottom-0 left-0 w-full opacity-50" />
    </section>;
}